import { z } from 'zod';

import { AdditionalSupplyChainActorSchema, TransportEquipmentSchema } from './utils';

export const TSDGoodsItemSchema = z.object({
  goodsItemNumber: z.string().optional().nullable(),
  packaging: z
    .array(
      z
        .object({
          typeOfPackages: z.string().optional().nullable(),
          numberOfPackages: z.string().optional().nullable(),
          shippingMarks: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  commodity: z
    .object({
      descriptionOfGoods: z.string().optional().nullable(),
      cusCode: z.string().optional().nullable(),
      commodityCode: z
        .object({
          hsCode: z.string().optional().nullable(),
          harmonizedSystemSubHeadingCode: z.string().optional().nullable(),
          combinedNomenclatureCode: z.string().optional().nullable(),
        })
        .optional(),
    })
    .optional(),
  weight: z
    .object({
      grossMass: z.string().optional().nullable(),
    })
    .optional(),
  additionalSupplyChainActor: AdditionalSupplyChainActorSchema,
  transportEquipment: TransportEquipmentSchema,
  previousDocuments: z
    .array(
      z
        .object({
          type: z.string().optional().nullable(),
          referenceNumber: z.string().optional().nullable(),
          goodsItemIdentifier: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  additionalInformation: z
    .array(
      z
        .object({
          code: z.string().optional().nullable(),
          text: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  supportingDocuments: z
    .array(
      z
        .object({
          type: z.string().optional().nullable(),
          referenceNumber: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
  additionalReference: z
    .array(
      z
        .object({
          type: z.string().optional().nullable(),
          referenceNumber: z.string().optional().nullable(),
        })
        .optional(),
    )
    .optional(),
});
export type TSDViewEditGoodsItemFormValues = z.infer<typeof TSDGoodsItemSchema>;
